import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPicture = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4A5666",
		fillRule: "nonzero",
		d: "M0 2.276A2.275 2.275 0 0 1 2.276 0h15.448A2.275 2.275 0 0 1 20 2.276v15.448A2.275 2.275 0 0 1 17.724 20H2.276A2.275 2.275 0 0 1 0 17.724zm18.5 8.847V1.958a.466.466 0 0 0-.475-.458H1.975a.466.466 0 0 0-.475.458v10.984l2.166-2.085a.97.97 0 0 1 1.234-.084l3.07 2.216 5.09-5.717a.97.97 0 0 1 1.386-.051zm-17 6.851c0 .292.211.526.475.526h16.05c.264 0 .475-.234.475-.523v-4.701l-4.594-4.527-5.198 5.801c-.324.42-.886.489-1.284.157L4.422 12.54 1.5 15.337zM6 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
	})
});
export default SvgPicture;
